// Grössen-Buttons: Grid-Spalten dynamisch auf Anzahl Buttons setzen
function initSwatchGrid() {
  document.querySelectorAll('.block-swatch-list').forEach(function(list) {
    var count = list.querySelectorAll('.block-swatch').length;
    list.style.setProperty('--swatch-count', count);
  });
}

document.addEventListener('DOMContentLoaded', initSwatchGrid);

// Auch nach Variant-Wechsel neu initialisieren (falls Shopify die Liste neu rendert)
document.addEventListener('variant:changed', initSwatchGrid);
